import React, { Component, createRef } from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames';
import './calculator-overlay.style.scss';

const ESCAPE_KEYCODE = 27;

class CalculatorOverlay extends Component {
  constructor(props) {
    super(props);
    this.overlayRef = createRef();
  }

  state = {};

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', this.onPopstate, false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
    window.removeEventListener('popstate', this.onPopstate, false);
  }

  onPopstate = () => {
    const { handleClose, overlayOpened } = this.props;
    if (overlayOpened) {
      handleClose();
    }
  };

  escFunction = (event) => {
    const { overlayOpened } = this.props;

    if (overlayOpened && event && event.keyCode === ESCAPE_KEYCODE) {
      this.handleOverlayClosure();
    }
  };

  handleClickOutside = (event) => {
    const { overlayOpened } = this.props;
    if (!this.overlayRef.current) return;

    if (!this.overlayRef.current.contains(event.target) && event.target.tagName !== 'SPAN') {
      if (overlayOpened) {
        this.handleOverlayClosure();
      }
    }
  };

  handleCloseButtonClick = () => {
    const { overlayOpened } = this.props;
    if (overlayOpened) {
      this.handleOverlayClosure();
    }
  };

  handleOverlayClosure = () => {
    const { handleClose } = this.props;
    handleClose();
  };

  render() {
    const {
      overlayOpened, channel, handleClose
    } = this.props;
    const showHideClassName = classNames('calculator-overlay', {
      'calculator-overlay--block': overlayOpened,
      'calculator-overlay--hidden': !overlayOpened
    });
    const wrapperClassName = classNames('calculator-overlay__wrapper', {
      'calculator-overlay__wrapper__desktop': channel === 'desktop',
      'calculator-overlay__wrapper__mobile': channel === 'mobile'
    });
    const imageClassName = classNames('calculator-overlay__image-wrapper', {
      'calculator-overlay__image-wrapper__mobile': channel === 'mobile'
    });
    const closeDesktopClassName = classNames({
      'calculator-overlay--hidden': channel === 'desktop',
      'calculator-overlay__header-mobile': channel === 'mobile'
    });
    const closeMobileClassName = classNames({
      'calculator-overlay__close-button': channel === 'desktop',
      'calculator-overlay--hidden': channel === 'mobile'
    });
    const description = 'How to Measure Backsplash Dimensions';
    const tip1 = '1. Determine which kitchen type you are measuring.';
    const tip2 = '2. Using a measuring tape, measure the width and height of each area in inches.';
    const tip3 = '3. Input each area dimensions into Home Depot calculator.';
    if (overlayOpened) {
      document.addEventListener('click', this.handleClickOutside);
      document.body.style.overflow = 'hidden';
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }

    return (
      <div className={showHideClassName}>
        <section className={wrapperClassName} ref={this.overlayRef}>

          <button type="button" className={closeDesktopClassName} onClick={handleClose}>
            <img
              className="calculator-overlay__back-icon"
              src="https://assets.homedepot-static.com/images/v1/back-arrow-orange.svg"
              alt="Back"
            />
            <span className="calculator-overlay__back-text">Back</span>
          </button>

          <div className="calculator-overlay__header">
            <span className="calculator-overlay__description">
              {description}
            </span>
            <button type="button" className={closeMobileClassName} onClick={this.handleCloseButtonClick}>
              <span className="u__bold">Close</span>
              <img
                className="calculator-overlay__close"
                src="https://assets.homedepot-static.com/images/v1/close-symbol-orange.svg"
                alt="close"
              />
            </button>
          </div>
          <div className="calculator-overlay__tips">
            <ul>
              {`${tip1}`}
            </ul>
            <ul>
              {`${tip2}`}
            </ul>
            <ul>
              {`${tip3}`}
            </ul>
          </div>
          <div className="calculator-overlay__images">
            <div className={imageClassName}>
              <span className="calculator-overlay__type u__bold">Kitchen Type 1</span>
              <img
                className="calculator-overlay__image"
                src="https://assets.homedepot-static.com/images/v1/kitchen-type-1-calculator.svg"
                alt="kitchen type 1"
              />
            </div>
            <div className={imageClassName}>
              <span className="calculator-overlay__type u__bold">Kitchen Type 2</span>
              <img
                className="calculator-overlay__image"
                src="https://assets.homedepot-static.com/images/v1/kitchen-type-2-calculator.svg"
                alt="kitchen type 2"
              />
            </div>
            <div className={imageClassName}>
              <span className="calculator-overlay__type u__bold">Kitchen Type 3</span>
              <img
                className="calculator-overlay__image"
                src="https://assets.homedepot-static.com/images/v1/kitchen-type-3-calculator.svg"
                alt="kitchen type 3"
              />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

CalculatorOverlay.propTypes = {
  handleClose: func.isRequired,
  overlayOpened: bool,
  channel: string
};

CalculatorOverlay.defaultProps = {
  overlayOpened: false,
  channel: 'desktop'
};

export { CalculatorOverlay };
